import React, { useEffect } from 'react';
import { META_PIXEL_ID, initMetaPixel } from '../utils/metaPixel';
import { SiteHeader } from '../components/landing/SiteHeader';
import { Hero } from '../components/landing/Hero';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { StepsSection } from '../components/landing/StepsSection';
import { PathsSection } from '../components/landing/PathsSection';
import { TrustSection } from '../components/landing/TrustSection';
import { FaqSection } from '../components/landing/FaqSection';
import { UrgencySection } from '../components/landing/UrgencySection';
import { FinalCtaSection } from '../components/landing/FinalCtaSection';
import { SiteFooter } from '../components/landing/SiteFooter';
import { StickyCta } from '../components/landing/StickyCta';
export function Landing() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="h-full w-full overflow-y-auto bg-[#08090b]" data-id="element-144" data-mp="2atkipzxufgy">
      <noscript data-id="element-145" data-mp="3tgla9o9szq38">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-146" data-mp="3tg1xsn2x9twl" />
      </noscript>
      <SiteHeader data-id="element-147" data-mp="3kh7vqh6tobbn" />
      <main data-id="element-148" data-mp="3khq2w8v0w9yc">
        <Hero data-id="element-149" data-mp="3khzpdmguzyza" />
        <ProblemSection data-id="element-150" data-mp="l09x4bowdydq" />
        <SolutionSection data-id="element-151" data-mp="kzgm2yiwomps" />
        <BenefitsSection data-id="element-152" data-mp="kzqf6uz8z9zp" />
        <StepsSection data-id="element-153" data-mp="l2cp319m21l3" />
        <PathsSection data-id="element-154" data-mp="gyen8iswicoc" />
        <TrustSection data-id="element-155" data-mp="gzzk4f2ou7pd" />
        <FaqSection data-id="element-156" data-mp="gzpzz84bqurl" />
        <UrgencySection data-id="element-157" data-mp="h1aly9ckp5du" />
        <FinalCtaSection data-id="element-158" data-mp="c7ofiyx05xqh" />
      </main>
      <SiteFooter data-id="element-159" data-mp="c6n6t13glnbx" />
      <StickyCta data-id="element-160" data-mp="c63k772v6ark" />
    </div>;
}